import { AfterViewInit, Component, input, OnInit } from '@angular/core';
import { Chart, BarController, LineController, LineElement, BarElement, CategoryScale, LinearScale, TimeScale, PointElement, Title, Tooltip, Legend, registerables } from 'chart.js';

@Component({
  selector: 'app-pchart',
  standalone: false,
  templateUrl: './pchart.component.html',
  styleUrl: './pchart.component.css',
})
export class PchartComponent implements AfterViewInit, OnInit {

  uuid = 'chart-' + crypto.randomUUID();
  type = input.required<string>();
  data = input.required<any>();
  options = input<any>();


  public chart: any;


  constructor() {
    Chart.register(LineController, LineElement, BarController, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend, TimeScale, LineController, PointElement, LineElement);

  }

  ngOnInit() {
    console.log(this.type());
    console.log(this.data());
    console.log(this.options());


  }

  ngAfterViewInit() {
    this.render();
  }

  render() {
    const data = this.data();

    const chartData = {
      type: 'line',
      data,
      options: this.options() || {}

    };

    this.chart = new Chart(this.uuid, chartData);
  }

}
